import React, { useContext } from "react";
import { CheckoutContext } from "../../context/CheckoutContext";
import { AuthContext } from "../../context/AuthContext";
import SubmitButton from "../common/SubmitButton";

const CheckoutDiscount = ({ class_package_id }) => {
  const { user } = useContext(AuthContext);

  const { class_package, discountCode, setDiscountCode, spinnerDescuento, validarDescuento } =
    useContext(CheckoutContext);

  const handleSubmitDescuento = (e) => {
    e.preventDefault();
    validarDescuento(discountCode, class_package_id);
  };

  const renderDescuento = () => {
    if (user !== null) {
      if(class_package && class_package !== null) {
        if(parseFloat(class_package.price) === 0.0) {
          return <></>;
        }
      }
      return (
        <form className="card no-scale" onSubmit={handleSubmitDescuento}>
          <label className="bold">Código de Descuento</label>
          <div className="row">
            <div className="col-md-6 col-12 my-2">
              <input
                type="text"
                className="form-control"
                value={discountCode}
                onChange={(e) => setDiscountCode(e.target.value)}
              />
            </div>
            <div className="col-md-6 col-12 my-2">
              <SubmitButton
                label="Aplicar"
                spinner={spinnerDescuento}
                className="btn btn-outline-primary w-100"
              />
            </div>
          </div>
        </form>
      );
    }
  };

  return <div>{renderDescuento()}</div>;
};

export default CheckoutDiscount;
